import React, { useMemo, useState } from "react";
import styled from "styled-components";
import LoadingIndicator from "react-loading-indicator";
import { CollapsibleText, SearchBar } from "./Components";
import { searchOptions } from "./utils";
import { TabSlider, TabContent } from "./Components/TabSlider.jsx";
import { withRefluxStore, PreviewStore } from "../../../Stores";

const TeaserOption = styled.div`
  width: 100%;
  padding: 6px 10px;
  white-space: pre-wrap;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s;
  user-select: none;
  margin-bottom: 10px;
  border: 1px solid #e8e8eb;
  background-color: ${(props) => (props.dark ? "#44424C90" : "#fff")};
  &:hover {
    background-color: ${(props) => (props.dark ? "#44424C" : "#f2f2f2")};
  }
`;
const SearchBarWrapper = styled.div`
  margin-bottom: 10px;
`;
const NoResultText = styled.div`
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  width: 100%;
`;

const TeaserOptions = ({
  campaignData,
  teaserOptions,
  defaultTeaserTemplates,
  loadingTeaserOptions,
  // props
  teaserTextStyle,
  channel,
  applyOption,
  dark,
  isAutoGenerated,
  autoGeneratedText
}) => {
  const [searchTextTemplates, setSearchTextTemplates] = useState("");
  const [searchTextWebsite, setSearchTextWebsite] = useState("");
  const [searchTextHistorical, setSearchTextHistorical] = useState("");
  const [selectedTab, setSelectedTab] = useState(
    teaserOptions?.historicalPanel?.[channel]?.length ? "Historical" : "Suggestions"
  );

  const filteredTemplates = useMemo(() => {
    const templates = teaserOptions.templatePanel[channel] || [
      ...(isAutoGenerated && autoGeneratedText ? [autoGeneratedText] : []),
      ...defaultTeaserTemplates
    ];

    return searchOptions({
      options: templates,
      searchText: searchTextTemplates
    });
  }, [
    autoGeneratedText,
    channel,
    defaultTeaserTemplates,
    isAutoGenerated,
    searchTextTemplates,
    teaserOptions.templatePanel
  ]);

  const filteredWebsite = useMemo(
    () =>
      searchOptions({
        options: teaserOptions.websitePanel[channel],
        searchText: searchTextWebsite
      }),
    [channel, searchTextWebsite, teaserOptions.websitePanel]
  );

  const filteredHistorical = useMemo(
    () =>
      searchOptions({
        options: teaserOptions.historicalPanel[channel],
        searchText: searchTextHistorical
      }),
    [channel, searchTextHistorical, teaserOptions.historicalPanel]
  );

  return (
    <TabSlider
      tabs={["Suggestions", "Website Source", "Historical"]}
      width={384}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
    >
      <TabContent>
        <SearchBarWrapper>
          <SearchBar onChange={setSearchTextTemplates} />
        </SearchBarWrapper>
        {loadingTeaserOptions ? (
          <LoadingIndicator />
        ) : (
          filteredTemplates.map((option) => (
            <TeaserOption
              dark={dark}
              key={option}
              onClick={() => applyOption(option?.replace("{{jobTitle}}", campaignData.jobTitle))}
            >
              <CollapsibleText
                text={option?.replace("{{jobTitle}}", campaignData.jobTitle)}
                textStyle={teaserTextStyle}
              />
            </TeaserOption>
          ))
        )}
      </TabContent>
      <TabContent>
        <SearchBarWrapper>
          <SearchBar onChange={setSearchTextWebsite} />
        </SearchBarWrapper>
        {loadingTeaserOptions ? (
          <LoadingIndicator />
        ) : filteredWebsite?.length ? (
          filteredWebsite.map((option) => (
            <TeaserOption key={option} onClick={() => applyOption(option)}>
              <CollapsibleText text={option} textStyle={teaserTextStyle} />
            </TeaserOption>
          ))
        ) : (
          <NoResultText>No Results Found</NoResultText>
        )}
      </TabContent>
      <TabContent>
        <SearchBarWrapper>
          <SearchBar onChange={setSearchTextHistorical} />
        </SearchBarWrapper>
        {loadingTeaserOptions ? (
          <LoadingIndicator />
        ) : filteredHistorical?.length ? (
          filteredHistorical.map((option) => (
            <TeaserOption key={option} onClick={() => applyOption(option)}>
              <CollapsibleText text={option} textStyle={teaserTextStyle} />
            </TeaserOption>
          ))
        ) : (
          <NoResultText>No Results Found</NoResultText>
        )}
      </TabContent>
    </TabSlider>
  );
};

export default withRefluxStore(
  TeaserOptions,
  [PreviewStore],
  ["campaignData", "teaserOptions", "defaultTeaserTemplates", "loadingTeaserOptions"]
);
